<template lang="pug">
.container
  .row.d-none.d-lg-flex(
    v-for="(claimInfo, index) in docDescriptions.ClaimInfo_area02_List",
    :key="index"
  )
    .col-12
      .doc_descriptions.d-flex.flex-column.align-items-center
        img(:src="claimInfo.ClaimInfo_area02_Image")
        h4 {{ claimInfo.ClaimInfo_area02_Title }}
        .doc_content.d-flex
          .prepare
            li(
              v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
              :key="index"
            )
              a(
                v-if="doc.area02_DocContent01_FileURL",
                :href="doc.area02_DocContent01_FileURL",
                target="_blank"
              ) {{ doc.area02_DocContent01_Title }}
                svg-icon(iconClass="ic_download", className="icon business")
              span(v-else) {{ doc.area02_DocContent01_Title }}
  .row.d-lg-none(
    v-for="(claimInfo, index) in docDescriptions.ClaimInfo_area02_List",
    :key="index"
  )
    .col-12
      .doc_descriptions
        .doc_content
          .main_title.d-flex.align-items-center
            img(:src="claimInfo.ClaimInfo_area02_Image")
            h4.i_ml_2 {{ claimInfo.ClaimInfo_area02_Title }}

          .items.flex-column.flex-md-row.i_mt_md_4
            .prepare.flex-grow-1
              li(
                v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
                :key="index"
              )
                a(
                  v-if="doc.area02_DocContent01_FileURL",
                  :href="doc.area02_DocContent01_FileURL",
                  target="_blank"
                ) {{ doc.area02_DocContent01_Title }}
                  svg-icon(iconClass="ic_download", className="icon business")
                span(v-else) {{ doc.area02_DocContent01_Title }}
</template>

<script>
export default {
  name: "DocDescriptions",
  props: {
    docDescriptions: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/cliam_settlement_info/doc_descriptions";

@media (min-width: 992px) {
  .doc_content {
    width: 800px;
    height: auto;
    margin: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
    border-radius: 5px;
    box-shadow: 5px 7px 5px 0 rgba(158, 158, 158, 0.25);
    border: solid 1px $color_blue_btn;
    background-color: #ffffff;
  }
}

.items {
  display: block;
}

.prepare {
  margin: auto;
}

@media (max-width: 991px) and (min-width: 768px) {
  li a {
    font-size: 14px;
  }
}
</style>
